import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../providers/local-storage/local-storage.service';
import { of } from 'rxjs';

export const webAppGuard: CanActivateFn = (_route, _state) => {
  const localStorage = inject(LocalStorageService);
  const router = inject(Router);

  if (!localStorage.getIsInAppBrowser()) {
    return of(true);
  } else {
    router.navigateByUrl("/intervention-overview");
    return of(false);
  }
};